import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherTeachingExperience = () => {
  const { profileDetails } = useProfileContext()
  const teachingExperience = profileDetails?.teacher?.teachingExperience || []
  const industryExperience = profileDetails?.teacher?.industryExperience || []

  if (teachingExperience.length === 0 && industryExperience.length === 0) {
    return null
  }

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10 space-y-6">
        {teachingExperience.length > 0 && (
          <div>
            <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
              Teaching experience
            </h2>
            <ul className="list-disc list-inside space-y-2 text-grey-900 text-base">
              {teachingExperience.map((item, idx) => (
                <li key={`teaching-${idx}-${item}`}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        {industryExperience.length > 0 && (
          <div>
            <h3 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
              Industry experience
            </h3>
            <ul className="list-disc list-inside space-y-2 text-grey-900 text-base">
              {industryExperience.map((item, idx) => (
                <li key={`industry-${idx}-${item}`}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </section>
    </>
  )
}

export default React.memo(TeacherTeachingExperience)
